export const flattenObject = (input: any) =>
  Object.assign(
    {},
    ...(function flatten(o: any): any {
      return [].concat(...Object.keys(o).map((k: any) => (typeof o[k] === "object" ? flatten(o[k]) : { [k]: o[k] })));
    })(input)
  );
